import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { configTypeMap } from '@app/dev/terminal/components/eventTypeFilter/constants';
import EventTypeFilter from '@app/dev/terminal/components/eventTypeFilter';
import { casinoGamesPageOpened } from '@app/dev/actions/terminal';
import { changeSecondScreen } from '@common/helpers/secondScreen';
import { usePrevious } from '@common/hooks/previous';
import Config from '@skin_config';
import { ThirdPartyGameIDEnum, thirdPartyGamesConfig } from './constants';
import { HandleLotteryGame } from '../../../helpers/casino/helpers';

import './style.scss';

const ThirdPartyGame = () => {
  const iframeRef = useRef();
  const dispatch = useDispatch();
  const { id } = useParams();
  const prevId = usePrevious(id);
  const [iframeUrl, setIframeUrl] = useState();
  const user = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();
  const loadPromise = useRef(Promise.withResolvers());

  const handler = useMemo(() => {
    const { Handler } = thirdPartyGamesConfig[id] || {};
    return Handler ? new Handler() : null;
  }, [id]);

  useEffect(() => {
    window.addEventListener('message', (message) => {
      message.source === iframeRef?.current?.contentWindow && handler?.onIframeMessage(message);
    });

    return () => changeSecondScreen(Config, {
      command: 'Default',
      id: 0,
      url: '',
      providerId: 0,
    });
  }, [handler]);

  useEffect(() => {
    let mounted = true;

    (async () => {
      await loadPromise.current?.promise;
      if (mounted && searchParams.get('action')) handler?.onActionNeeded?.(iframeRef.current);
    })();

    return () => {
      mounted = false;
    };
  }, [searchParams, handler, iframeRef, loadPromise]);

  useEffect(() => {
    const {
      limitgroupId, tableId, hasSecondScreen, openType,
    } = thirdPartyGamesConfig[id] || {};

    id !== prevId && Config.ticketBasedGameIds.includes(id) && dispatch(casinoGamesPageOpened());
    setIframeUrl(HandleLotteryGame(user, [id], false, limitgroupId, tableId, openType));

    if (hasSecondScreen) {
      const upperScreenUrl = HandleLotteryGame(user, [id], true, limitgroupId, tableId, openType);

      if (upperScreenUrl) {
        changeSecondScreen(Config, {
          command: 'Video',
          id: 111,
          url: upperScreenUrl,
          providerId: 54,
        });
      }
    }
  }, [id, prevId, user]);

  return (
    <div className="third-party-game-wrapper">
      <div className="casino-games-list">
        <EventTypeFilter
          listType={ThirdPartyGameIDEnum[id]}
          configType={configTypeMap.virtualGames}
        />
      </div>
      <div className="third-party-iframe-wrapper">
        <iframe
          key={`${iframeUrl}`}
          src={iframeUrl}
          ref={iframeRef}
          onLoad={() => loadPromise.current?.resolve(true)}
        />
      </div>
    </div>
  );
};

export default ThirdPartyGame;
